<template>
    <b-card>
      <b-row>
        <b-col md="6">
          <h3>{{ $route.name }}</h3>
          <!-- breadcrumb -->
          <b-breadcrumb>
            <b-breadcrumb-item
              ><router-link to="/dashboard/">Dashboard</router-link></b-breadcrumb-item
            >
            <b-breadcrumb-item
              ><router-link to="/inventory/stock-in">Stock In</router-link></b-breadcrumb-item
            >
            <b-breadcrumb-item active>{{ $route.name }}</b-breadcrumb-item>
          </b-breadcrumb>
          <!-- end breadcrumb -->
        </b-col>
      </b-row>
      <div>
        <!-- ============ FORM ADD STOCK IN ================== -->
        <b-form v-on:submit.prevent="doSubmit">
          <b-row>
            <!-- BEGIN FORM ID TRANDACTION -->
            <b-col md="3">
              <div v-if="this.$route.params.id !== null && this.$route.params.id !== undefined">
                <label class="labels">Id transaction</label>
                <b-form-input v-model="model.stockInId" placeholder="Transaction ID"></b-form-input>
              </div>
              <div v-else>
                <label class="labels">Id transaction</label>
                <b-form-input v-model="model.stockInId" placeholder="Transaction ID"></b-form-input>
              </div>
            </b-col>
            <!-- END FORM ID TRANSACTION -->
            <b-col md="1"></b-col>
            <b-col md="3">
             <!-- BEGIN FORM STOCK AREA -->
              <div v-if="this.$route.params.id !== null && this.$route.params.id !== undefined">
              <label class="labels">Stock Area *</label>
              <div class="form-group d-flex" style="height: 2.25rem">
                <b-input
                  list="stocks"
                  v-model="model.selectedStockAreaName"
                  name="stock"
                  v-bind:class="errors.has('selectedJournalAccount') ? 'has-error' : ''"
                  v-validate="'required'"
                  placeholder="Journal Account"
                  style="height: 100%"
                  required
                />
                <datalist id="stocks">
                  <option
                    v-for="(stock, index) in stockAreaList"
                    :key="index"
                    :value="stock.text"
                  />
                </datalist>
                <p v-if="errors.has('stock') !== null"></p>
              </div>
              </div>
              <div v-else>
                <label class="labels">Stock Area</label>
                <div class="form-group d-flex" style="height: 2.25rem">
                <b-input
                  list="stocks"
                  v-model="model.selectedStockAreaName"
                  name="stock"
                  v-bind:class="errors.has('selectedJournalAccount') ? 'has-error' : ''"
                  v-validate="'required'"
                  placeholder="Stock Area"
                  style="height: 100%"
                  required
                />
                <datalist id="stocks">
                  <option
                    v-for="(stock, index) in stockAreaList"
                    :key="index"
                    :value="stock.text"
                  />
                </datalist>
                <p v-if="errors.has('stock') !== null"></p>
              </div>
              <!-- END FORM STOCK AREA -->
              </div>
            </b-col>
            <b-col md="1"></b-col>
            <b-col md="3">
              <!-- BEGIN FORM JOURNAL -->
              <div v-if="this.$route.params.id !== null && this.$route.params.id !== undefined">
              <label class="labels">Journal Account</label>
              <div class="form-group d-flex" style="height: 2.25rem">
                <b-input
                  list="journals"
                  v-model="model.selectedJournalAccount"
                  name="selectedJournalAccount"
                  v-bind:class="errors.has('selectedJournalAccount') ? 'has-error' : ''"
                  v-validate="'required'"
                  placeholder="Journal Account"
                  style="height: 100%"
                  required
                />
                <datalist id="journals">
                  <option
                    v-for="(journal, index) in journalAccountList"
                    :key="index"
                    :value="journal.text"
                    @click="addToSelected(availableItem)"
                  />
                </datalist>
                <p v-if="errors.has('selectedJournalAccount') !== null"></p>
              </div>
              </div>
              <div v-else>
                <label class="labels">Journal Account</label>
                <div class="form-group d-flex" style="height: 2.25rem">
                <b-input
                  list="journals"
                  v-model="model.selectedJournalAccount"
                  name="selectedJournalAccount"
                  v-bind:class="errors.has('selectedJournalAccount') ? 'has-error' : ''"
                  v-validate="'required'"
                  placeholder="Journal Account"
                  style="height: 100%"
                  required
                />
                <datalist id="journals">
                  <option
                    v-for="(journal, index) in journalAccountList"
                    :key="index"
                    :value="journal.text"
                    @click="addToSelected(availableItem)"
                  />
                </datalist>
                <p v-if="errors.has('selectedJournalAccount') !== null"></p>
              </div>
              </div>
              <!-- END FORM JOURNAL -->
            </b-col>
          </b-row>
          <b-row>
            <b-col md="3">
              <label class="labels">Date</label>
              <div class="form-group" v-bind:class="errors.has('stockInDate') ? 'has-error' : ''">
                  <b-form-datepicker
                    type="date"
                    :min="min"
                    class="form-control"
                    v-bind:class="errors.has('stockInDate') ? 'is-invalid' : ''"
                    data-vv-as="dueDate"
                    name="stockInDate"
                    v-model="model.stockInDate"
                    placeholder="Date"
                  />
                  <p v-if="errors.has('stockInDate') !== null"></p>
              </div>
            </b-col>
            <b-col md="1"></b-col>
            <b-col md="7">
              <div v-if="this.$route.params.id !== null && this.$route.params.id !== undefined">
              <label class="labels">Description</label>
              <b-form-input v-model="model.stockInNote" placeholder="Description"></b-form-input>
              </div>
              <div v-else>
              <label class="labels">Description</label>
              <b-form-input v-model="model.stockInNote" placeholder="Description"></b-form-input>
              </div>
            </b-col>
          </b-row>
          <b-row class="mt-3">
          <b-col md="12" class="mt-3">
            <div class="table-responsive">
              <table>
                <thead>
                  <tr class="small-text border-bottom py-5">
                    <th width="500">Item*</th>
                    <th width="100" class="text-center">Quantity</th>
                    <th width="100" class="text-center">Price / Unit</th>
                    <th width="100" class="text-center">Unit</th>
                    <th width="400" class="text-left ml-1"><p class="mt-3 ml-4">Description</p></th>
                  </tr>
                </thead>
                <tbody>
                  <template v-for="(selectedItem, index) in selectedItems">
                    <tr v-if="!selectedItem.isDeleted" :key="selectedItem.uuid">
                      <td width="500">
                        <b-form-input
                          v-model="selectedItem.name"
                          :plaintext="!selectedItem.isCustomItem"
                          required
                          class="selected small-text"
                          style="margin-top:15px!important;"
                          placeholder="Enter Item"
                        />
                      </td>
                      <td width="100">
                        <b-form-input
                          v-model="selectedItem.stockQty"
                          :plaintext="selectedItem.isCustomItem"
                          type="number"
                          required
                          class="text-center selected small-text"
                          style="margin-top:15px!important;"
                          placeholder="Quantity"
                        />
                      </td>

                     <td width="250">
                        <money
                          v-bind="money"
                          v-model="selectedItem.stockPrice"
                          :plaintext="selectedItem.isCustomItem"
                          required
                          class="text-center form-control text-right selected small-text"
                          style="margin-top:15px!important;"
                          placeholder="Price"
                        />
                      </td>
                       <td width="100" v-if="selectedItem.isUnit"
                      >
                        <b-form-input
                          v-model="selectedItem.isUnit.name"
                          :plaintext="!selectedItem.isCustomItem"
                          type="text"
                          style="margin-top:15px!important;"
                          class="text-center selected small-text"
                          placeholder="..."
                        />
            
                      </td>
                      <td width="500">
                        <textarea
                          v-model="selectedItem.stockNote"
                          :plaintext="selectedItem.isCustomItem"
                          class="m-3 selected small-text form-control"
                          type="text"
                          placeholder="Note ..."
                        ></textarea>
                      </td>
                      <td class="text-center">
                      <b-button
                        pill
                        v-b-tooltip.hover.right
                        title="Delete Row"
                        style="margin-bottom:5px!important;margin-left: 22px;font-weight:bold!important;padding-top:0px!important; padding-bottom:0px!important;"
                        size="sm"
                        variant="danger"
                        @click="deleteSelectedItem(index)"
                      >
                        x
                      </b-button>
                    </td>
                    </tr>
                  </template>
                </tbody>
              </table>
            </div>
          </b-col>
        </b-row>
         <b-row>
          <b-col md="6">
            <b-dropdown text="Add Item" variant="dark">
              <div
                style="overflow: scroll; height: 250px; width:489px; border-bottom: 1px solid black"
              >
                <v-select
                  multiple
                  v-model="selectedItems"
                  style="width: 100%;"
                  id="mySelect"
                  label="name"
                  @input="addToSelected(availableItem.uuid)"
                  :options="availableItems"
                  :reduce="(uuid) => uuid"
                  class="style-chooser mt-1"
                  placeholder="Type to search Items"
                ></v-select>
                <b-dropdown-divider></b-dropdown-divider>
              </div>
            </b-dropdown>
          </b-col>
        </b-row>
              
          <b-row class="h-75">
            <b-col></b-col>
            <b-col></b-col>
            <b-col></b-col>
          </b-row>
          <b-row class="mt-5 mb-4 pb-2">
              <b-col md="6">
                <b-button variant="secondary" class="btn-back float-left" @click="goBack()"
                  ><font-awesome-icon icon="chevron-circle-left"></font-awesome-icon> Back</b-button
                >
              </b-col>
              <b-col md="6">
                <div v-if="loadingButton" class="float-right">
                  <b-button variant="warning" disabled>
                    <b-spinner small type="grow"></b-spinner>
                    Loading...
                  </b-button>
                </div>
                <div v-else>
                  <b-button
                    :disabled="!disable"
                    variant="primary"
                    class="btn-back float-right"
                    type="submit"
                    ><font-awesome-icon icon="save"></font-awesome-icon>
                    Save
                  </b-button>
                </div>
              </b-col>
            </b-row>
        </b-form>
      </div>
      <!-- <b-row class="mt-2">
        <b-col md="12">
        </b-col>
      </b-row> -->
    </b-card>
</template>
<script>
import Vue from 'vue'
import 'vue2-datepicker/index.css';
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';
Vue.use(vSelect, 'v-select');
import {Money} from 'v-money'

export default {
  components: { Money },
  data() {
     const now = new Date()
      const today = new Date(now.getFullYear(), now.getMonth(), now.getDate())
      // 15th two months prior
      const minDate = new Date(today)
      minDate.setMonth(minDate.getMonth() - 2)
      minDate.setDate(15)
      // 15th in two months
      const maxDate = new Date(today)
      maxDate.setMonth(maxDate.getMonth() + 2)
      maxDate.setDate(15)
    return {
      min: minDate,
      max: maxDate,
      loadingButton: false,
      index: 0,
      isCustomItem: false,
      addItem: true,
      apiUrl: {
        journal: window.AppConfig.apiUrl + 'journal-account',
        stock: window.AppConfig.apiUrl + 'stock-area',
        stockIn: window.AppConfig.apiUrl + 'stock-in'
      },

      //formatter curency
      money: {
          thousands: '.',
          prefix: '',
          suffix: '',
          precision: 0,
          masked: false
        },
      model: {
        stockInId: '',
        stockInDate: null,
        stockInNote: '',
        stockArea: null,
        journalAccount: null,
        stockInItemNote: '',
        stockInItemQuantity: null,
        stockInItemPrice: null,
        stockInItemCogs: null,
        itemList: null,
        stockIn: null,
        selectedJournalAccount: '',
        selectedStockAreaName: '',
        selectedItemNameList: '',
      },
      journalAccountList: [],
      itemListData: [],
      table: {
        selectedItemNameList: '',
        selectedItemQty: '',
        selectedItemPrice: '',
        selectedItemNote: '',
        itemList: '',
      },
      collectionStockInItem: [],
      itemChoice: '',
      isDeleted: false,
      selectedItems: [],
      selectedItem: {},
      availableItems: [],
      dataCustomer: [],
      dataItem: '',
      customerSales: '',
      currency: '',
      stockAreaList: []
    };
  },
  mounted() {
    this.fetchJournalAccount();
    this.fetchItemList();
    this.fetchAvailableItems();
    this.fetchStockArea();
    this.initData();
  },

  computed: {
    disable() {
      if (this.selectedItems.length !== 0) {
        return true;
      }
      return false;
    },
  },

  watch: {
    //
  },

  methods: {
    initData(){
      if(this.$route.params.id !== undefined){
        this.getDetail()
      }
    },

    doSubmit() {
      this.loadingButton = true
      const toSubmit = this.selectedItems.map(selectedItem =>({
        uuid: '',
        itemList: selectedItem.isCustomItem ? '' : selectedItem.uuid,
        stockInItemPrice: selectedItem.stockPrice,
        stockInItemQuantity: selectedItem.stockQty,
        stockInItemNote: selectedItem.stockNote,
        delete: 0
      }));
      let selected = this.model.selectedJournalAccount;
      this.model.journalAccount = this.journalAccountList.find((item) => { return item.text === selected })?.value ?? null;

      let choice = this.model.selectedStockAreaName;
      this.model.stockArea = this.stockAreaList.find(area=>{ return area.text === choice })?.value ?? null;
      this.$validator.validateAll().then(()=>{
          let formData = new FormData();
          formData.append('stockArea', this.model.stockArea)
          formData.append('journalAccount', this.model.journalAccount)
          formData.append('stockInNote', this.model.stockInNote)
          formData.append('stockInDate', this.getDateTime(this.model.stockInDate))
          formData.append('stockInId', this.model.stockInId)
          formData.append('stockInItem', JSON.stringify(toSubmit))
        this.$http.post(this.apiUrl.stockIn, formData).then(response=>{
          this.$store.dispatch('notification/success', 'Stock In has been Added')
          this.loadingButton = false
          window.location.href = document.URL.replace('/create', '/' + response.data.uuid);
        })
        .catch((error) => {
          this.$store.dispatch('notification/error', error);
          this.loadingButton = false;
        });
      })
  },
    

    /** 
     * function getDetail
     * use to get data from server 
     */   
    getDetail(){
      this.$http.get(this.apiUrl.stockIn + '/' + this.$route.params.id).then(response=>{
        this.model.stockInId = response.data.stockInId !== null ? response.data.stockInId : '-'
        this.model.stockInDate = response.data.stockInDate !== null
              ? this.$moment(response.data.stockInDate  ).format('YYYY-MM-DD')
              : null;
        this.model.stockInNote = response.data.stockInNote !== null ? response.data.stockInNote : '-'
        this.model.stockArea = response.data.stockArea !== null ? response.data.stockArea.uuid : '-'
        this.model.selectedStockAreaName = response.data.stockArea !== null ? response.data.stockArea.areaName : '-'
        this.model.journalAccount = response.data.journalAccount !== null ? response.data.journalAccount.uuid : '-'
        this.model.selectedJournalAccount = response.data.journalAccount !== null ? response.data.journalAccount.journalAccountName : '-'
        if(response.data.stockInItem){
          this.selectedItems = response.data.stockInItem.map((selectedItem) =>{
            return {
              uuid: selectedItem.uuid ? selectedItem.uuid : '-',
              itemUuid: selectedItem.itemList ? selectedItem.itemList.uuid : '-',
              name: selectedItem.itemList ? selectedItem.itemList.name : selectedItem.itemList.name,
              stockNote: selectedItem.stockInItemNote ? selectedItem.stockInItemNote : '',
              stockPrice: selectedItem.stockInItemPrice ? selectedItem.stockInItemPrice : 0,
              stockQty: selectedItem.stockInItemQuantity ? selectedItem.stockInItemQuantity : 0,
              isDeleted: false,
              isNewItem: false,
            }
          })
        }
      }).catch(error=>{
        this.$store.dispatch("notification/error", error)
      })
    },


      /**
     * @function addToSelected
     * @param {{ isManuallyEntered, name, orderQuantity, uuid }} item
     * add the item object into selectedItems array.
     */
    addToSelected: function(item) {
      this.selectedItems.push(item);
      console.log(this.selectedItems);
    },

    /**
     * @function createCustomItem
     * create an empty input fields to enter items
     * that is currently not in the database.
     */
    createCustomItem: function() {
      this.addToSelected({
        uuid: '',
        name: '',
        taxValue: null,
        orderQuantity: 0,
        isUnit: null,
        isNote: '',
        isCustomItem: true,
        isDeleted: false,
      });
    },

     /**
     * @function deleteSelectedItem
     * @param { Number } index
     * delete an item from the selectedItems array,
     * and from the quotation form.
     */
    deleteSelectedItem: function(index) {
      this.selectedItems.splice(index, 1);
    },


    /**
     * @function getRemainingAvailableItems
     * get availableItems that is not yet added into selectedItems
     * by extracting UUIDs from selectedItems into selectedItemsUUID array
     * then filter out items whose UUID is in the selectedItemsUUID array.
     */
    getRemainingAvailableItems: function() {
      const selectedItemsUUID = this.selectedItems.map(({ uuid }) => uuid);
      return this.availableItems.filter(
        (availableItem) => !selectedItemsUUID.includes(availableItem.uuid),
      );
    },

    resetTableForm() {
      this.table = [];
    },

    /** use to get journal account from server */
    fetchJournalAccount() {
      this.$http
        .get(this.apiUrl.journal + '?journalAccountType=D')
        .then((resp) => {
          this.journalAccountList = [];
          resp.data._embedded.journal_account.forEach((journal) => {
            this.journalAccountList.push({
              value: journal.uuid,
              text:
                journal.journalAccountType +
                ' - ' +
                journal.journalAccountCode +
                ' - ' +
                journal.journalAccountName,
            });
          });
        })
        .catch((error) => console.log(error));
    },

    /** 
     * fetch Stock Area from server
     */
    fetchStockArea(){
      this.$http.get(this.apiUrl.stock).then(resp=>{
        this.stockAreaList = []
        resp.data._embedded.stock_area.forEach(area=>{
          this.stockAreaList.push({
            value: area.uuid,
            text: area.areaName
          })
        })
      }).catch(error=>{this.$store.dispatch("notification/error", error)})
    },

    /**
     * use to get item for server
     */
    fetchItemList() {
      this.$http.get(window.AppConfig.apiUrl + 'item-list?limit=1000').then((response) => {
        this.itemListData = [];
        response.data._embedded.item_list.forEach((item) => {
          this.itemListData.push({
            value: item.uuid,
            text: item.name,
          });
        });
      });
    },

    /**
     * @function fetchAvailableItems
     * @async
     * fetch items for sale from API then remap it
     *
     */
    fetchAvailableItems: async function() {
      const response = await this.$http.get(window.AppConfig.apiUrl + 'item-list');
      this.dataItem = response.data._embedded.item_list.name;
      this.availableItems = response.data._embedded.item_list.map((availableItem) => ({
        uuid: availableItem.uuid,
        name: availableItem.name,
        isUnit: availableItem.itemUnit,
        itemQty: 0,
        itemPrice: 0,
        itemNote: '',
        isCustomItem: false,
        isDeleted: false,
      }));
    },

    getDateTime(value) {
      if (value !== null) {
        return this.$moment(value).format('YYYY-MM-DD');
      } else {
        return '-';
      }
    },

    goBack() {
      window.goBack(this);
    },
  },
};
</script>
<style scoped>
.wrapper {
  overflow: hidden;
  position: relative; 
  padding-bottom: 46px;
}



.style-chooser .vs__open-indicator {
  fill: #394066;  
}
</style>